var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-6", attrs: { id: "pripady-table-filter-wrapper" } },
    [
      _c(
        "v-container",
        { staticClass: "pripady-table-filter pa-0" },
        [
          _c("h2", { staticClass: "pt-10 pb-4" }, [_vm._v("Filter")]),
          _c(
            "v-form",
            { attrs: { autocomplete: "off" } },
            [
              _c(
                "v-row",
                { staticClass: "mx-n4", attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "px-4",
                      attrs: { xl: "3", lg: "3", md: "3" }
                    },
                    [
                      _c("DynamicCombo", {
                        attrs: {
                          dynamic: "",
                          clearable: "",
                          "data-id": "liw_filip__obc_pripady__filter_stredisko",
                          autoload: "",
                          outlined: "",
                          cache: false,
                          lite: ""
                        },
                        model: {
                          value: _vm.idStrediska,
                          callback: function($$v) {
                            _vm.idStrediska = $$v
                          },
                          expression: "idStrediska"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "px-4",
                      attrs: { xl: "3", lg: "3", md: "3" }
                    },
                    [
                      _c("DynamicCombo", {
                        attrs: {
                          dynamic: "",
                          clearable: "",
                          cache: false,
                          "data-id": "liw_filip__obc_pripady__filter_dodavatel",
                          autoload: "",
                          outlined: "",
                          lite: ""
                        },
                        model: {
                          value: _vm.idDodavatela,
                          callback: function($$v) {
                            _vm.idDodavatela = $$v
                          },
                          expression: "idDodavatela"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "px-4",
                      attrs: { xl: "3", lg: "3", md: "3" }
                    },
                    [
                      _c("date-picker", {
                        attrs: {
                          placeholder: "DD/MM/YYYY - DD/MM/YYYY",
                          label: "Dátum vytvorenia OP/LZ",
                          cache: false,
                          range: ""
                        },
                        model: {
                          value: _vm.datumVytvorenia,
                          callback: function($$v) {
                            _vm.datumVytvorenia = $$v
                          },
                          expression: "datumVytvorenia"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "px-4",
                      attrs: { xl: "3", lg: "3", md: "3" }
                    },
                    [
                      _c("date-picker", {
                        attrs: {
                          placeholder: "DD/MM/YYYY - DD/MM/YYYY",
                          label: "Dátum modifikácie OP/LZ",
                          cache: false,
                          range: ""
                        },
                        model: {
                          value: _vm.datumModifikacie,
                          callback: function($$v) {
                            _vm.datumModifikacie = $$v
                          },
                          expression: "datumModifikacie"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { xl: "8", lg: "8", md: "8" } },
                [
                  _c(
                    "v-btn-toggle",
                    {
                      staticClass: "mt-2",
                      attrs: { multiple: "", group: "" },
                      model: {
                        value: _vm.stav,
                        callback: function($$v) {
                          _vm.stav = $$v
                        },
                        expression: "stav"
                      }
                    },
                    _vm._l(_vm.stavFilter, function(ref, index) {
                      var nazov = ref.nazov
                      var hodnota = ref.hodnota
                      return _c(
                        "v-btn",
                        {
                          key: index,
                          attrs: { small: "", "data-id": hodnota }
                        },
                        [
                          _vm._v(" " + _vm._s(nazov) + " "),
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                right: "",
                                dark: "",
                                size: "14",
                                color: "#0097FD"
                              }
                            },
                            [_vm._v(" mdi-check ")]
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { xl: "4", lg: "4", md: "4" } },
                [
                  _c(
                    "div",
                    { staticClass: "right" },
                    [
                      _c(
                        "v-dialog",
                        {
                          attrs: {
                            "max-width": "400",
                            "overlay-color": "black",
                            "overlay-opacity": "0.8"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-secondary btn-icon"
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c("v-icon", { attrs: { size: "18" } }, [
                                        _vm._v("mdi-filter-menu-outline")
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.dialog,
                            callback: function($$v) {
                              _vm.dialog = $$v
                            },
                            expression: "dialog"
                          }
                        },
                        [
                          _c(
                            "v-card",
                            [
                              _c("v-card-title", { staticClass: "headline" }, [
                                _vm._v(" Filter ")
                              ]),
                              _c(
                                "v-card-text",
                                { staticClass: "px-6" },
                                [
                                  _c(
                                    "v-form",
                                    { attrs: { autocomplete: "off" } },
                                    [
                                      _c("text-box", {
                                        attrs: {
                                          label: "Nájomca",
                                          cache: false
                                        },
                                        model: {
                                          value: _vm.najomca,
                                          callback: function($$v) {
                                            _vm.najomca = $$v
                                          },
                                          expression: "najomca"
                                        }
                                      }),
                                      _c("text-box", {
                                        attrs: {
                                          label: "Nájomca ičo",
                                          cache: false
                                        },
                                        model: {
                                          value: _vm.ico,
                                          callback: function($$v) {
                                            _vm.ico = $$v
                                          },
                                          expression: "ico"
                                        }
                                      }),
                                      _c("text-box", {
                                        attrs: {
                                          label: "Číslo obch. prípadu",
                                          max: 12,
                                          cache: false
                                        },
                                        model: {
                                          value: _vm.cisloObchPripadu,
                                          callback: function($$v) {
                                            _vm.cisloObchPripadu = $$v
                                          },
                                          expression: "cisloObchPripadu"
                                        }
                                      }),
                                      _c("text-box", {
                                        attrs: {
                                          label: "Číslo plz",
                                          max: 12,
                                          cache: false
                                        },
                                        model: {
                                          value: _vm.cisloPlz,
                                          callback: function($$v) {
                                            _vm.cisloPlz = $$v
                                          },
                                          expression: "cisloPlz"
                                        }
                                      }),
                                      _c("text-box", {
                                        attrs: {
                                          label: "Číslo lz",
                                          cache: false,
                                          max: 12
                                        },
                                        model: {
                                          value: _vm.cisloLz,
                                          callback: function($$v) {
                                            _vm.cisloLz = $$v
                                          },
                                          expression: "cisloLz"
                                        }
                                      }),
                                      _c("dynamic-combo", {
                                        attrs: {
                                          dynamic: "",
                                          clearable: "",
                                          multiple: "",
                                          cache: false,
                                          dataId:
                                            "liw_filip__obc_pripady__filter_stav_lz",
                                          autoload: "",
                                          lite: ""
                                        },
                                        model: {
                                          value: _vm.stavLz,
                                          callback: function($$v) {
                                            _vm.stavLz = $$v
                                          },
                                          expression: "stavLz"
                                        }
                                      }),
                                      _c("dynamic-combo", {
                                        attrs: {
                                          dynamic: "",
                                          clearable: "",
                                          cache: false,
                                          dataId:
                                            "liw_filip__obc_pripady__filter_dimenzia",
                                          autoload: "",
                                          lite: ""
                                        },
                                        model: {
                                          value: _vm.dimenzia,
                                          callback: function($$v) {
                                            _vm.dimenzia = $$v
                                          },
                                          expression: "dimenzia"
                                        }
                                      }),
                                      _c("dynamic-combo", {
                                        attrs: {
                                          dynamic: "",
                                          clearable: "",
                                          cache: false,
                                          dataId:
                                            "liw_filip__obc_pripady__filter_zdroj_ponuky",
                                          autoload: "",
                                          lite: ""
                                        },
                                        model: {
                                          value: _vm.zdrojPonuky,
                                          callback: function($$v) {
                                            _vm.zdrojPonuky = $$v
                                          },
                                          expression: "zdrojPonuky"
                                        }
                                      }),
                                      _c("CheckBox", {
                                        staticClass: "mt-n16px",
                                        attrs: { label: "Je rozpracovaný" },
                                        model: {
                                          value: _vm.jeRozpracovany,
                                          callback: function($$v) {
                                            _vm.jeRozpracovany = $$v
                                          },
                                          expression: "jeRozpracovany"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-card-actions",
                                [
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "btn-primary",
                                      attrs: { text: "" },
                                      on: { click: _vm.applyFilter }
                                    },
                                    [_vm._v(" Filtrovať ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-primary right mr-5",
                      on: { click: _vm.applyFilter }
                    },
                    [_vm._v("Filtrovať")]
                  ),
                  _c(
                    "v-fade-transition",
                    [
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showReset,
                              expression: "showReset"
                            }
                          ],
                          staticClass: "right btn-secondary mr-5",
                          attrs: { id: "btn-filter-reset" },
                          on: { click: _vm.resetFilter }
                        },
                        [_vm._v("Resetovať filter")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }